// extracted by mini-css-extract-plugin
export default {"cautionBox":"p7-z"};